import React, {ReactElement} from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import {useIntl} from 'react-intl';
import AccordionWithTitleAndSubHeading from '../../DesignSystem/AccordionWithTitleAndSubHeading/AccordionWithTitleAndSubHeading';
import {AccordionStartOpen} from '../../DesignSystem/Accordion/Accordion';
import {Locale, useLocale} from '../../../RootProvider/LocaleContext';
import {Accordion} from '../../../types';
import {getNodesByLocale} from '../../../localeUtils/getNodesByLocale';

function HomepageKnowMoreAccordionWithQuery(): ReactElement | null {
  const locale = useLocale();
  const {locale: language} = useIntl();

  const data = useStaticQuery(graphql`
    query HomePageKnowMoreAccordion {
      allContentfulAccordion(filter: {contentful_id: {eq: "5LPaGDgIaktgjM3mxkCTUa"}}) {
        nodes {
          ...Accordion
        }
      }
    }
  `);

  const accordions: Accordion[] = getNodesByLocale<Accordion>(
    data.allContentfulAccordion.nodes,
    locale,
    language as Locale
  );

  if (!accordions.length) {
    return null;
  }

  const {accordionName, subheading, items} = accordions[0];

  return (
    <AccordionWithTitleAndSubHeading
      queryItems={items}
      accordionName={accordionName}
      subheading={subheading}
      startOpen={AccordionStartOpen.FIRST}
    />
  );
}

export default HomepageKnowMoreAccordionWithQuery;
